import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import Message from '../../../common/message/Message';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	ONBOARDING_PRIVACY_TITLE,
	ONBOARDING_PRIVACY_DESCRIPTION,
	ONBOARDING_PRIVACY_CTA,
	CONDITIONS_URL_DPG,
	ONBOARDING_TERMS_USER_CONDITIONS,
	ONBOARDING_PRIVACY_URL,
	ONBOARDING_PRIVACY_LINK,
} from '../../../../constants/TermsAndConditions';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';

import './RegisterPrivacy.scss';

const RegisterPrivacy = ({ submitting, handleSubmit }) => {
	return (
		<form method="POST" onSubmit={handleSubmit} className="onboarding-privacy">
			<OnboardingProgress activeStep={2} />
			<Heading className="onboarding-privacy__title">{ONBOARDING_PRIVACY_TITLE}</Heading>
			<p className="onboarding__text onboarding-privacy__text">
				<Message
					message={ONBOARDING_PRIVACY_DESCRIPTION}
					values={{
						termsandconditions: (
							<a className="onboarding__link" target="_blank" href={CONDITIONS_URL_DPG}>
								{ONBOARDING_TERMS_USER_CONDITIONS}
							</a>
						),
						privacy: (
							<a className="onboarding__link" target="_blank" href={ONBOARDING_PRIVACY_URL}>
								{ONBOARDING_PRIVACY_LINK}
							</a>
						),
					}}
				/>
			</p>
			<Button testId="privacy-button" loading={submitting} type="submit" onClick={handleSubmit}>
				{ONBOARDING_PRIVACY_CTA}
			</Button>
		</form>
	);
};

RegisterPrivacy.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
	form: 'register',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
})(RegisterPrivacy);
